import Decimal from 'decimal.js'

// 保留一位小数；没有可用袋数时保持为空。
export const normalizeProcessingBagsPerDose = (
  value: unknown
): number | null => {
  if (value == null || value === '') return null
  const bags = Number(value)
  return Number.isFinite(bags) && bags >= 0
    ? new Decimal(bags).toDecimalPlaces(1, Decimal.ROUND_HALF_UP).toNumber()
    : null
}

const zeroBagFrequencies = new Set([
  '隔周1次',
  '必要时',
  '顿服',
  '少量频服',
  '随时服用',
])

// 将“几日/周几剂（次）”换算成每天的剂数（次数）。未知自定义文本不猜测。
const dailyRate = (text: string, unit: '剂' | '次') => {
  const normalized = text.replace(/\s/g, '')
  if (unit === '次' && normalized === '隔日1次') return new Decimal(1).div(2)
  const match = normalized.match(
    new RegExp(`^(\\d+(?:\\.\\d+)?)(日|天|周)(半?)(\\d+(?:\\.\\d+)?)${unit}$`)
  )
  if (!match) return null
  const days = new Decimal(match[1])
    .plus(match[3] ? 0.5 : 0)
    .times(match[2] === '周' ? 7 : 1)
  return days.gt(0) ? new Decimal(match[4]).div(days) : null
}

export const getProcessingBagsPerDose = (
  frequency: string = '',
  frequencyUnit: string = ''
): number | null => {
  const doseText = String(frequency ?? '').replace(/\s/g, '')
  const timesText = String(frequencyUnit ?? '').replace(/\s/g, '')
  if (zeroBagFrequencies.has(doseText) || zeroBagFrequencies.has(timesText)) {
    return null
  }
  const doses = dailyRate(doseText, '剂')
  const times = dailyRate(timesText, '次')
  // 与 ABC 一致：先将每剂袋数四舍五入到一位，再计算总袋数。
  return doses?.gt(0) && times
    ? times.div(doses).toDecimalPlaces(1, Decimal.ROUND_HALF_UP).toNumber()
    : null
}

export const getProcessingTotalBags = (
  quantity: unknown,
  bagsPerDose: unknown
) => {
  if (
    quantity == null ||
    quantity === '' ||
    bagsPerDose == null ||
    bagsPerDose === ''
  )
    return null
  const doses = Number(quantity)
  const bags = Number(bagsPerDose)
  return Number.isFinite(doses) &&
    doses >= 0 &&
    Number.isFinite(bags) &&
    bags >= 0
    ? new Decimal(doses).times(bags).ceil().toNumber()
    : 0
}
